// extracted by mini-css-extract-plugin
export default {"no-results-section":"tqsLTFHix4bRj12lwP9m","noResultsSection":"tqsLTFHix4bRj12lwP9m"};